import React, { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { isEmpty } from "lodash";

import selectStyles from '../../util/selectStyles';
import PropertyList from './PropertyList';

const TextWithVariables = ({
  label = '',
  field = '',
  value = '',
  variableLabel = 'Añadir variable',
  updateValue,
  customerColumns,
  errors = {},
  classNameTextArea = '',
}) => {
  const textareaRef = useRef(null);

  const [displayProperties, setDisplayProperties] = useState(false);
  const [displayPropertyList, setDisplayPropertyList] = useState(false);
  const [variableOptions, setVariableOptions] = useState([]);
  const [caretPosition, setCaretPosition] = useState({ start: null });

  useEffect(() => {
    if (isEmpty(customerColumns)) return;

    const options = customerColumns.map((field) => ({
      value: field[1],
      label: (<span className="fz-14">{field[0]} <small className="c-grey">{`{{${field[1]}}}`}</small></span>)
    }));

    setVariableOptions(options);
  }, [customerColumns]);

  const handleInputChange = (e) => {
    updateValue(field, e.target.value);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === '@') {
      setDisplayPropertyList(true);
    } else if (displayPropertyList) {
      setDisplayPropertyList(false);
    }
  };

  const handleCaretPosition = (e) => {
    const { selectionStart, selectionEnd } = e.target;

    setCaretPosition({ start: selectionStart, end: selectionEnd, setCaret: true });
  };

  const handleDisplayVariables = () => {
    setDisplayProperties(!displayProperties);
  };

  const handleSelect = (option) => {
    insertFieldInput(option.value);
  };

  const formatedTextToAdd = (inputValue) => {
    let curPos = caretPosition.start;
    // const { value } = formData;

    if (curPos == null) curPos = value.length;

    const textToAdd = `{{${inputValue}}}`;

    if (curPos == 0 && value.slice(curPos + 1) === ' ') return textToAdd;
    if (curPos == 0 && value.slice(curPos + 1) !== ' ') return `${textToAdd} `;

    if (value.slice(curPos - 1) === ' ' && value.slice(curPos + 1) !== ' ') return `${textToAdd} `;
    if (value.slice(curPos - 1) !== ' ' && value.slice(curPos + 1) === ' ') return ` ${textToAdd}`;
    if (value.slice(curPos - 1) !== ' ' && value.slice(curPos + 1) === '') return ` ${textToAdd}`;

    return ` ${textToAdd} `;
  };

  const insertFieldInput = (inputValue) => {
    let curPos = caretPosition.start;
    // const { value } = formData;

    if (curPos == null) curPos = value.length;

    const textToAdd = formatedTextToAdd(inputValue);

    const newValue = value.slice(0, curPos) + textToAdd + value.slice(curPos);

    updateValue(field, newValue);
    setDisplayProperties(false);
  };

  const updateFieldInput = (inputValue) => {
    let curPos = caretPosition.start;
    // const { value } = formData;

    if (curPos == null) curPos = value.length;

    const textToAdd = formatedTextToAdd(inputValue[1]);

    const newValue = value.slice(0, curPos - 1) + textToAdd + value.slice(curPos);

    updateValue(field, newValue);
    setDisplayPropertyList(false);
  };

  return (
    <>
      <div className="col-12">
        <div className={`figma-field mb-0 ${classNameTextArea}`}>
          <label>{label}</label>
          <span className="ml-10 error-msg fz-12">{errors[field]}</span>
          <textarea
            ref={textareaRef}
            name={field}
            className="mercately-input mercately-input-textarea textarea-counter"
            value={value}
            onChange={handleInputChange}
            onFocus={handleCaretPosition}
            onBlur={handleCaretPosition}
            onKeyDown={handleOnKeyDown}
            rows={2}
            maxLength="1000"
          />
        </div>
        {displayPropertyList && (
          <PropertyList
            properties={customerColumns}
            insertFieldInput={updateFieldInput}
            customStyles={{ top: '90px', left: '45px', height: '255px' }}
          />
        )}
      </div>

      {!displayProperties && (
        <div className="col-md-12 mt-10 mb-10 text-right">
          <button className="chats-add-note-button" onClick={handleDisplayVariables}>
            <span className="text-blue fz-14">{variableLabel}</span>
          </button>
        </div>
      )}
      {displayProperties && (
        <div className="col-12">
          <div className="col-md-12 d-flex flex-row mt-20 justify-content-between px-0">
            <div className="w-100 px-0">
              <div className="figma-field mb-0">
                <label>Variables</label>
                <Select
                  options={variableOptions}
                  placeholder="selecciona un campo"
                  className="select-tag"
                  classNamePrefix="select-tag"
                  styles={selectStyles}
                  onChange={handleSelect}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-center">
              <span onClick={handleDisplayVariables} className="cursor-pointer">
                <i className="mi-close-outline fz-30" />
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TextWithVariables;
